import { FormAPI, ApiUtil, ProcessAPI } from 'lecom-api';
import GridFormValidator from 'validator/grid_form_validator';
import { FormEvents } from 'form/events/form_event_handler';
import { generateUUID } from 'utils/uuid';
import UpdateRowHandler from './update_row_handler';
import InsertRowHandler from './insert_row_handler';
import ResetHandler from './reset_handler';

const execute = (gridFormName, dataRowProps, totalCount, commands, initialValues, formAction) => {
	return new Promise((resolve, reject) => {
		publishGridSubmit(gridFormName, dataRowProps.submittedDataRow, formAction);		

		const subscribeEvent = new Promise((resolve, reject) => {							
			const gridFormFieldAPI = ApiUtil.getFieldAPI(gridFormName);			

			if (formAction === 'create') {			
				gridFormFieldAPI.publish(FormEvents.GRID_ADD_BEFORE, dataRowProps.submittedDataRow, dataRowProps.dataRows, resolve, reject);
			}
			else {			
				gridFormFieldAPI.publish(FormEvents.GRID_EDIT_BEFORE, dataRowProps.submittedDataRow, dataRowProps.dataRows, resolve, reject);
			}			
			
			resolve(dataRowProps.submittedDataRow);
		});	

		subscribeEvent
			.then(submittedDataRow => {																
				const dataRowPropsUpdatted = { ...dataRowProps, submittedDataRow: submittedDataRow || dataRowProps.submittedDataRow };
				const errorsInputRequired = validateGridFormFields(gridFormName);										

				if (!Object.keys(errorsInputRequired).length) {
					getFormAPI().errors({}).apply();

					const resetResult = ResetHandler.execute(gridFormName, initialValues);

					const result = {
						...resetResult,
						...insertOrUpdateDataRow(totalCount, commands, dataRowPropsUpdatted),
						waitForAction: true,
					}																												
					
					resolve({ result, submittedDataRow: submittedDataRow || dataRowProps.submittedDataRow });			
				}
				else {					
					reject(errorsInputRequired);
				}
			})
			.catch(err => {
				reject(err);
			});				
	});	
};

const getFormAPI = () => {
	const formId = ProcessAPI.currentProcess().form().get('id');
	const formAPI = FormAPI.form(formId);
	return formAPI;
};

const publishGridSubmit = (gridFormName, submittedDataRow, formAction) => {
	const gridFormFieldAPI = ApiUtil.getFieldAPI(gridFormName);

	if(formAction === 'create'){
		gridFormFieldAPI.publish(FormEvents.GRID_SUBMIT, submittedDataRow);
		gridFormFieldAPI.publish(FormEvents.GRID_ADD_SUBMIT, submittedDataRow);		
	} else {
		gridFormFieldAPI.publish(FormEvents.GRID_SUBMIT, submittedDataRow);
		gridFormFieldAPI.publish(FormEvents.GRID_EDIT_SUBMIT, submittedDataRow);		
	}
};

const validateGridFormFields = (gridFormName) => {
	const formFields = getFormAPI().fields(gridFormName).fields().map(field => field.get());
	return GridFormValidator.validate(formFields);
};

const insertOrUpdateDataRow = (totalCount, commands, dataRowProps) => {	
	const { clientSideIdField, dataRows, submittedDataRow } = dataRowProps;
	const dataRowsIds = dataRows.map(dataRow => dataRow[clientSideIdField]);
	const submittedDataRowExistsInStore = dataRowsIds.includes(submittedDataRow[clientSideIdField]);
	const formattedDataRowProps = { ...dataRowProps, dataRow: submittedDataRow };	

	return submittedDataRowExistsInStore	
		? UpdateRowHandler.execute(commands, formattedDataRowProps)
		: InsertRowHandler.execute(formattedDataRowProps, totalCount, commands);
};

export default {
	execute
};
